import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './styles.css';

const { getNumberOfDays } = require('../../../lib/bputils').default;

const NewBadge = ({ height, width, expiryDate }) => {
  const daysLeftToHide = getNumberOfDays(moment(), expiryDate);

  if (daysLeftToHide <= 0) {
    return (<></>);
  }

  return (
    <span className={styles.newBadgeContainer}>
      <img
        src="/images/app/new-badge.svg"
        alt="New Feature"
        height={height}
        width={width}
      />
    </span>
  );
};

NewBadge.propTypes = {
  expiryDate: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
};

NewBadge.defaultProps = {
  height: 22,
  width: 46,
};

export default NewBadge;
